import axios from '@/store/vue-axios'
import Vue from 'vue'

export default {
  SET_AUTH_TOKEN (state, {authToken}) {
    axios.defaults.headers['Authorization'] = 'Bearer ' + authToken

    return localStorage !== undefined ?
      localStorage.setItem('authToken', authToken) :
      Vue.cookie.set("authToken", authToken)
  }

}



// WEBPACK FOOTER //
// ./src/store/mutations.js